import { connectHook } from 'app/common/components/connect-hook';
import { GraphQL } from './graphql.js';
import { useGraphQL } from './graphql-hook.js';

export default connectHook(GraphQL, useGraphQL);
